<template>
  <w-setting-sliding-popup ref="slidingPopup" class="popups" :title="targetAgentTitle" width="620px" @close="close">
    <div slot="content">
      <el-scrollbar class="setting-container">
        <div class="title-popup">스케줄 정보</div>
        <el-table class="popup-band" :data="tableDataForIp">
          <el-table-column prop="name" width="200">
          </el-table-column>
          <el-table-column prop="data" width="360">
          </el-table-column>
        </el-table>

        <el-row class="color-wrapper">
          <span class="color used"></span><span class="color-title"> 사용</span>
          <span class="color"></span><span class="color-title"> 미사용</span>
          <span class="color subnet"></span><span class="color-title"> Subnet</span>
          <span class="color boardcast"></span><span class="color-title"> Board</span>
        </el-row>

        <div class="content" style="margin-top: 10px; margin-bottom: 10px; width:98%;">
          <div v-if="targetList.length > 0">
            <el-row v-for="i in 16" :key="i" type="flex" justify="space-around" style="margin-bottom: 4px;">
              <div v-for="j in 16" :key="j">
                <el-tooltip :disabled="!(targetList[(i-1)*16 + (j-1)].tooltipFlag)">
                  <div slot="content">
                    <p><span>1. 장비 | </span><span>{{targetList[(i-1)*16 + (j-1)].hostname}} </span></p>
                    <p><span>2. IP | </span><span>{{targetList[(i-1)*16 + (j-1)].ipAddress}} </span></p>
                    <p><span>3. MAC | </span><span>{{targetList[(i-1)*16 + (j-1)].mac}} </span></p>
                  </div>
                  <el-button :class="`node-mini status${targetList[(i-1)*16 + (j-1)].text}`" :style="'background:'+ targetList[(i-1)*16 + (j-1)].background +'; color:'+ targetList[(i-1)*16 + (j-1)].textColor +';'+
                    'display: flex; align-items: center; justify-content: center;'">{{ targetList[(i-1)*16 + (j-1)].text }}
                  </el-button>
                </el-tooltip>
              </div>
            </el-row>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import NetdeviceIpManagement from '@/api/settings/netdevice/netdevice-ip-management';

export default {
  name: 'WIpUsageSlidingPopup',
  data() {
    return {
      targetAgentTitle: '',
      targetData: {},
      targetList: [],
      netStatusList: [],
      ipSplitList: [],
      tableDataForIp: [],
    };
  },
  methods: {
    open(item) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.targetAgentTitle = `${item.ip}  |  IP 사용현황`;
        this.targetData = item;

        // table 형태에 맞게 push
        this.tableDataForIp.push({ name: 'IP 대역', data: this.targetData.ip });
        this.tableDataForIp.push({ name: '확인 시각', data: this.getDateFormatter(this.targetData.issueDate) });
        this.tableDataForIp.push({ name: '서브넷마스크', data: this.targetData.subnet });

        this.ipSplitList = item.ip.split('.');
        const params = {
          scanId: item.scanId,
          networkIp: `${this.ipSplitList[0]}.${this.ipSplitList[1]}.${this.ipSplitList[2]}.`,
          ipaddress: item.ipaddress,
          subnet: item.subnetNum,
        };
        NetdeviceIpManagement.getNetStatusList(params).then((response) => {
          if (response.data.success) {
            this.netStatusList = response.data.data;
            this.generateForIpList();
            this.checkingIpStatus();
          }
        });
      });
    },
    close() {
      this.tableDataForIp = [];
      this.initIpChart();
    },
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    // Ip 상태 현황 리스트 생성
    generateForIpList() {
      this.networkIp = `${this.ipSplitList[0]}.${this.ipSplitList[1]}.${this.ipSplitList[2]}.`;
      const subnetToken = this.targetData.subnet.substring(this.targetData.subnet.indexOf('(') + 1, this.targetData.subnet.indexOf(')')).split('.')[3];
      let mask = 128;
      let count = 1;
      while ((subnetToken & mask) !== 0) {
        mask = mask >> 1;
        count *= 2;
      }
      const broad = (256 / count) - 1;
      const broadcastIp = Number(this.ipSplitList[3]) + broad;
      for (let i = 0; i <= 255; i += 1) {
        const param = {};

        // if (i < Number(this.ipSplitList[3]) || i > broadcastIp) {
        //   param.textColor = '#D6D6D6';
        // } else {
        //   param.textColor = 'black';
        // }
        //
        // 조회한 netStatusList 들을 찾아 targetList를 생성할 때 추가적인 값을 넣어준다.
        const findedNetStatus = this.netStatusList.find((item) =>
          item.ipAddress === `${this.ipSplitList[0]}.${this.ipSplitList[1]}.${this.ipSplitList[2]}.${i}`,
        );
        if (findedNetStatus) {
          param.background = '#1bb3e5';
          param.textColor = '#FFFF';
          param.tooltipFlag = true;
          param.hostname = `호스트명: ${findedNetStatus.hostname}`;
          param.ipAddress = `IP: ${findedNetStatus.ipAddress}`;
          param.mac = `MAC: ${findedNetStatus.mac}`;
        } else {
          param.background = '#FFFF';
          param.textColor = '#b4b4b4';
          param.tooltipFlag = false;
        }
        param.text = i;
        this.targetList.push(param);
      }
    },
    checkingIpStatus() {
      this.$nextTick(() => {
        if (document.getElementsByClassName(`status${this.ipSplitList[3]}`).length > 0) {
          document.getElementsByClassName(`status${this.ipSplitList[3]}`)[0].style.background = '#ff9801';
          document.getElementsByClassName(`status${this.ipSplitList[3]}`)[0].style.color = '#FFFF';
        }
        if (document.getElementsByClassName(`status${this.broadcastIP}`).length > 0) {
          document.getElementsByClassName(`status${this.broadcastIP}`)[0].style.background = '#673bb7';
          document.getElementsByClassName(`status${this.ipSplitList[3]}`)[0].style.color = '#FFFF';
        }
      });
    },
    initIpChart() {
      // for (let i = 0; i <= 255; i += 1) {
      //   this.targetList[i].textColor = 'black';
      //   this.targetList[i].tooltipFlag = false;
      //   this.targetList[i].background = '#F6F6F6';
      //   this.targetList[i].text = i;
      // }
      this.targetList = [];
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/IpManagementSettings/IpUsageStatusList/popup/IpUsageSlidingPopup.vue